import { styled } from "@mui/material/styles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useNavigate } from "react-router-dom";

type Props = {
  className?: string;
  Icon: any;
  link?: string;
  "data-test-id"?: string;
  onClick?: () => void;
};
export function OLStyledIcon({
  className = "",
  Icon,
  link = "",
  "data-test-id": dataTestId,
  onClick,
}: Props) {
  const navigate = useNavigate();
  const StyledIcon = styled(Icon)(({ theme }: { theme: OLTheme }) => ({
    background: theme.gray100,
    borderRadius: "50%",
    color: theme.gray500,
    cursor: "pointer",
    fontSize: 24,
    padding: theme.spacing(1),
    verticalAlign: "middle",
  }));

  return (
    <StyledIcon
      className={className}
      onClick={() => {
        link && navigate(link);
        onClick?.();
      }}
      data-test-id={dataTestId}
    />
  );
}
